import { useSelector } from "react-redux";

export default function useFinanceiroAtivo() {
	const financeiroAtivo = useSelector(
		(state) =>
			state.configuracoes?.financeiro_ativo ||
			state.configuracoes?.financeiro_ativo_asaas ||
			false,
	);

	return financeiroAtivo;
}

